export const FILL_ORDERS = 'FILL_ORDERS'
export const TOGGLE_SIDEBAR = 'TOOGLE_SIDEBAR'
export const SET_SELECTED_ORDERS = 'SET_SELECTED_ORDERS'
export const FILL_OCCURRENCES = 'FILL_OCCURRENCES'
export const APPEND_ORDERS = 'APPEND_ORDERS'
export const SET_PAGINATION = 'SET_PAGINATION'
export const RESET_ORDERS = 'RESET_ORDERS'
export const SET_CACHE_LOADED = 'SET_CACHE_LOADED'
export const SET_FILTER_DATE = 'SET_FILTER_DATE'